
const urlNotAllowed = [
    {
		url: 'mercadolibre.com',
		message: 'No se permite ingresar una página web de MercadoLibre',
	},
    {
		url: 'mercadoshops.com',
		message: 'No se permite ingresar una página web de MercadoShops',
	},
    {
		url: 'mercadoenvios.com',
		message: 'No se permite ingresar una página web de MercadoEnvios',
	},
    {
		url: 'mercadopago.com',
		message: 'No se permite ingresar una página web de MercadoPago',
	},
    {
		url: 'linktr.ee',
		message: 'No se permite ingresar una página web de Linktree',
	},
    {
		url: 'campsite.bio',
		message: 'No se permite ingresar una página web de Campsite',
	},
    {
		url: 'youtube.com',
		message: 'No se permite ingresar un perfil de Youtube como página web',
	},
    {
		url: 'instagram.com',
		message: 'No se permite ingresar un perfil de Instagram como página web',
	},
    {
		url: 'linkedin.com',
		message: 'No se permite ingresar un perfil de Linkedin como página web',
	},
    {
		url: 'facebook.com',
		message: 'No se permite ingresar un perfil de Facebook como página web',
	},
	{
		url: 'twitter.com',
		message: 'No se permite ingresar un perfil de Twitter como página web',
	},
];

export default urlNotAllowed
